export default {
  resetPasswordSuccess: 'Password Successfully Updated.',
  resetPasswordError: 'Something went wrong.'
};